import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 登录
/* interface HomeindexData {
    userName: string,
    password: string,
}
export const homeindex = (): any => http.httpPost({
    url: httpApi.home.homeindex,
    // data,
}) */

interface CaptchaBardData {
    needcode: number
}
// 验证码唯一id
export const CaptchaGuid = (json: CaptchaBardData): any => http.httpPost({
    url: httpApi.capt.captbard,
    json
})

// 获取login图片
export const CaptchaBard = (): any => http.httpPost({
    url: httpApi.capt.captbard,
})

interface UserInfoData {
    guid: string,
    username: string,
    password: string,
    promote_code: string
}
// 账号密码注册
export const userInfo = (json: UserInfoData): any => http.httpPost({
    url: httpApi.loginHome.userInfo,
    json
})

interface LoginInfoData {
    username: string,
    password: string
}
// 账号密码注册
export const LoginInfo = (json: LoginInfoData): any => http.httpPost({
    url: httpApi.loginHome.LoginInfo,
    json
})

// 手机号注册
interface UserPhoneData {
    phone: string,
    password: string,
    promote_code: string,
    code: string
}
export const UserPhone = (json: UserPhoneData): any => http.httpPost({
    url: httpApi.loginHome.UserPhone,
    json
})

// 登录,账号不存在则注册
interface JudgePhoneLogin {
    phone: string,
    promote_code: string,
    code: string
}
export const judgePhoneLogin = (json: JudgePhoneLogin): any => http.httpPost({
    url: httpApi.loginHome.judgePhoneLogin,
    json
})

// 绑定手机号
interface BindPhoneJson {
    username: string,
    password: string,
    phone: string,
    code: string
}
export const bindPhone = (json: BindPhoneJson): any => http.httpPost({
    url: httpApi.loginHome.bindPhone,
    json
})

// 验证账号是否已存在
interface AccountTestJson {
    username: string,
    password: string,
}
export const accountTest = (json: AccountTestJson): any => http.httpPost({
    url: httpApi.loginHome.accountTest,
    json
})

